module.exports = __webpack_public_path__ + "static/colorcontrast-720659779660605cbb8b0059d58d3032.png";